import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { SelectedInstituteService } from '@shared/service/selected-institute.service';
import { InstituteDto } from '@shared/constants/institute.constants';

export const agentFrontendEntityResolver: ResolveFn<InstituteDto | null> = (
  route: ActivatedRouteSnapshot
) => {
  const selectedInstituteService = inject(SelectedInstituteService);
  const entity = route.paramMap.get('entity');

  if (entity) {
    const institute = selectedInstituteService.getInstituteById(entity);
    if (institute) {
      selectedInstituteService.setInstitute(institute, false);
      return institute;
    }
  }

  return null;
};
